<script lang="ts">
    import { DEFAULT_LAYOUT } from '$lib/components/constants';

    import { getColor } from '$lib/helper';
    import { personalizeHtml } from '$lib/personalizeHtml';

    import LoaderView from './Loader.View.svelte';

    import type { LoaderContent } from '$lib/types/Components/Loader/LoaderContent';
    import type { Language } from '$lib/types/Language';
    import type { Theme } from '$lib/types/Theme';
    import type { TrackingProperty } from '$lib/types/TrackingProperty';

    export let id = '';
    export let content: LoaderContent;
    export let theme: Theme;
    export let layout = DEFAULT_LAYOUT;
    export let campaignId = '';
    export let trackingProperties: TrackingProperty[] = [];
    export let language: Language = 'en';

    const personalizedHtml = personalizeHtml(content.wysiwygHtml, {
        trackingProperties,
        campaignId,
        language,
    });
</script>

<LoaderView
    {id}
    wysiwygHtml={personalizedHtml}
    size={content.size}
    iconJsonUrl={content.iconJsonUrl}
    color={getColor(content.color, theme.buttonBackgroundColor)}
    box={content.box}
    {layout}
    textColor={theme.fontColor}
/>
